export const filtersTranslationNl = {
    search: "Zoeken",
    reset: "Reset",
    selectAll: "Alle",
    selectNone: "Geen",
    clearFilters: "Clear filters",
};
